module.exports = __webpack_public_path__ + "img/personal-mob.a95e22a9.png";